<main class="main-wrap">
    <div class="middle-wrapper">
      <app-report-subscription-page></app-report-subscription-page>
    </div>
    <div class="right-sidebar-wrapper">
      <app-micro-product-right-side-bar-page></app-micro-product-right-side-bar-page>
     </div>
  </main>
